import { Box } from '@mui/material'
import { Button } from 'Common/Supplyvue-ui'
import { HeaderElementProps } from './HeaderElement.types'
import { CloudDownload } from '@mui/icons-material'
import { DashboardActionsView } from '../DahboardActions/DashboardActions.view'
import { CircularProgress } from '@mui/material'

export const HeaderElementView = ({
  handlePrimaryButtonClick,
  handleEditCapacityClick,
  handleBowWaveClick,
  handleEditSettingsClick,
  handleAlternativeWorkcentres,
  isCapacityDataDownloading,
  isDataDownloading,
  planId,
  workcentreId,
  handleEditProduction,
}: HeaderElementProps) => {
  const downloading = isCapacityDataDownloading || isDataDownloading

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Button
        startIcon={!downloading && <CloudDownload />}
        variant="outlined"
        color="primary"
        onClick={handlePrimaryButtonClick}
        disabled={downloading}
        sx={{
          borderRadius: 0,
          height: '100%',
        }}
      >
        {downloading && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{
              marginRight: '8px',
            }}
          />
        )}
        Download
      </Button>
      <Box margin={1} />
      <DashboardActionsView
        planId={planId}
        workcentreId={workcentreId}
        enabled={true}
        handleEditCapacityClick={handleEditCapacityClick}
        handleBowWaveClick={handleBowWaveClick}
        handleEditSettingsClick={handleEditSettingsClick}
        handleAlternativeWorkcentres={handleAlternativeWorkcentres}
        handleEditProduction={handleEditProduction}
      />
    </Box>
  )
}
